// extracted by mini-css-extract-plugin
export var container = "_ma-0";
export var segment = "_ma-2";
export var segmentActive = "_ma-3";
export var track = "_ma-1";